export default "__VITE_ASSET__BkSjP7KQ__"